/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsTopActionableIssuesRequest {
    getFixupPrototypeFunction() { return AppSecopsTopActionableIssuesRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsTopActionableIssuesRequest>): AppSecopsTopActionableIssuesRequest {
        let obj = Object.assign(new AppSecopsTopActionableIssuesRequest(), model);
        AppSecopsTopActionableIssuesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsTopActionableIssuesRequest>): AppSecopsTopActionableIssuesRequest {
        if (!model) return null;
        return AppSecopsTopActionableIssuesRequest.newInstance(<AppSecopsTopActionableIssuesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsTopActionableIssuesRequest) {
        if (!obj) return;

        models.AppSecopsTopActionableIssuesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsTopActionableIssuesRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsTopActionableIssuesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AppSecopsTopActionableIssuesFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Filters for the request
     */
    filters: models.AppSecopsTopActionableIssuesFilter;

}
